/**
 * https://qiita.com/nqyutq/items/32fbcb56218594f4a341#%E3%83%88%E3%83%BC%E3%82%AF%E3%83%B3%E3%81%AE%E3%83%AA%E3%83%95%E3%83%AC%E3%83%83%E3%82%B7%E3%83%A5%E6%96%B9%E6%B3%95
 * https://www.bezkoder.com/vue-refresh-token/
 */

import Axios from 'axios'
import { Notify } from 'quasar'
import {gtm} from 'boot/gtmplugin'

const REFRESH_TOKEN_URL = '/swc-api/token/refresh/'
const MAX_REFRESH_RETRY_COUNT = 1
const REFRESH_RETRY_DELAY_MS = 1000
const LOGIN_REDIRECT_DELAY_MS = 5000
const TRANSIENT_REFRESH_ERROR_STATUSES = [502, 503, 504]

const http = Axios.create({
    baseURL: '/',
    withCredentials: true,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest"
    }
})

let refreshTokenPromise;

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const isRefreshRequest = (config) => config?.url === REFRESH_TOKEN_URL

const isTransientRefreshError = (error) => {
    const status = error?.response?.status
    return !error?.response || TRANSIENT_REFRESH_ERROR_STATUSES.includes(status)
}

const getErrorStatus = (error) => error?.response?.status || 'network-error'

const logRefreshEvent = (swacEvent, error, retryCount) => {
    gtm.logEvent(swacEvent, {
        auth_refresh_status: `${getErrorStatus(error)}`,
        auth_refresh_retry_count: retryCount,
        auth_refresh_retry_delay_ms: REFRESH_RETRY_DELAY_MS,
        auth_refresh_transient: isTransientRefreshError(error),
    })
}

const getRefreshToken = () => {
    return http.post(
        REFRESH_TOKEN_URL,
        {refresh: localStorage.getItem('auth/REFRESH_TOKEN')},
        {
            withCredentials: true,
            // headers: { 'X-CSRF-TOKEN': Vue.$cookies.get('csrf_refresh_token') }
        }
    ).then((res) => {
        return {accessToken: res.data.access, refreshToken: res.data.refresh}
    })
}

http.interceptors.response.use(
    config => {
        const token = localStorage.getItem('auth/ACCESS_TOKEN')
        config.headers['Authorization'] = 'Bearer ' + token
        return config
    },
    error => {
        if (isRefreshRequest(error.config)) {
            const refreshRetryCount = error.config._refreshRetryCount || 0

            if (isTransientRefreshError(error) && refreshRetryCount < MAX_REFRESH_RETRY_COUNT) {
                error.config._refreshRetryCount = refreshRetryCount + 1
                logRefreshEvent('auth_refresh_retry_scheduled', error, error.config._refreshRetryCount)
                return wait(REFRESH_RETRY_DELAY_MS)
                    .then(() => http.request(error.config))
                    .then((response) => {
                        gtm.logEvent('auth_refresh_retry_succeeded', {
                            auth_refresh_retry_count: error.config._refreshRetryCount,
                        })
                        return response
                    })
            }

            logRefreshEvent('auth_refresh_logout_scheduled', error, refreshRetryCount)

            Notify.create({
                type: "warning",
                message: isTransientRefreshError(error)
                    ? 'セッションの更新に失敗しました。通信状態を確認して、再度ログインしてください。'
                    : 'セッション情報の有効期限が切れました。再度ログインしてください。'
            })
            // 5秒後にログイン画面へ遷移
            setTimeout(() => {
                if (location.pathname != '/auth/login') {
                    location.href = '/auth/login'
                }
            }, LOGIN_REDIRECT_DELAY_MS)

            return Promise.reject(error)
        }
        if (error.config && error.response && error.response.status === 401 && !error.config._retry) {
            if (!refreshTokenPromise) {
                error.config._retry = true;
                refreshTokenPromise = getRefreshToken().finally(() => {
                    refreshTokenPromise = null
                })
            }

            return refreshTokenPromise.then(token => {
                // error.config.headers['X-CSRF-TOKEN'] = token
                const {accessToken, refreshToken} = token
                localStorage.setItem('auth/ACCESS_TOKEN', accessToken)
                localStorage.setItem('auth/REFRESH_TOKEN', refreshToken)
                error.config.headers['Authorization'] = 'Bearer ' + accessToken
                return http.request(error.config)
            })
        } else {
            Notify.create({
                type: "warning",
                message: `Server Response Error : ${error}`
              })
        }
        return Promise.reject(error)
    }
)

export default http
